// Please note that to enable features or switches they must
// also be added to features.yml in the checkout code base
export default {
  DISABLE_PAYPAL: 'disable_paypal',
  DISABLE_GOOGLE_PAY: 'disable_google_pay',
  APPLE_PAY: 'apple_pay',
  USE_REAL_LOQATE_OVERRIDE: 'use_real_loqate_override',
  USE_LOCAL_PAYPAL_SANDBOX_OVERRIDE: 'use_local_paypal_sandbox_override',
  LOG_ANALYTICS: 'logAnalytics',
  ALLOW_MY_JL_SIGN_UPS: 'join_my_jl',
  SHOW_RECOMMENDATIONS: 'show_recommendations',
  REQUEST_BILLING_ADDRESS_FROM_APPLE_PAY: 'request_billing_address_from_apple_pay',
  FORCE_CUSTOMER_APP_TYPE: 'force_customer_app_type',
  MEMBERS_WEEK_MESSAGING: 'members_week_messaging',
  FREE_CLICK_COLLECT: 'free_click_collect',
  SHOW_LIMITED_COLLECTION_DAYS_MESSAGE: 'show_limited_collection_days_message',
  TITLE_DROPDOWN_ENABLED: 'title_dropdown_enabled',
  DEFAULT_DELIVERY_TAB_ENABLED: 'default_delivery_tab_enabled',
  TEST_CRYPTOGRAM_IN_INTEGRATION: 'test_cryptogram_in_integration',
  ENABLE_FULFILMENT_PREFERENCE: 'enable_fulfilment_preference',
  ENABLE_KOUNT: 'enable_kount',
  SHOW_CALL_CENTRE_NUMBER_ON_3DS_ERROR: 'show_call_centre_number_on_3ds_error',
  SHOW_ESI_BANNER: 'show_esi_banner',
  RECOMMENDATIONS_SERVERSIDE_FETCH: 'recommendations_serverside_fetch',
  PAYPAL_PAY_IN_THREE_ENABLED: 'paypal_pay_in_three_enabled',
  CLICKABLE_PAYMENT: 'clickable_payment',
  ENABLE_PAYMENT_PREFERENCE: 'enable_payment_preference',
  ENABLE_CLEARPAY: 'enable_clearpay',
  USE_REAL_CLEARPAY: 'use_real_clearpay',
  APPLE_PAY_WITHOUT_SAVED_CARD: 'apple_pay_without_saved_card',
};
